<template>
  <div class="left">
    <div class="leftBox">
      <el-menu
        background-color="transparent"
        text-color="#fff"
        active-text-color="#3583ED"
        unique-opened
        :default-openeds="openeds"
        :default-active="$route.name"
      >
        <!-- 基础信息 -->
        <!-- 一级菜单 -->
        <el-submenu index="1">
          <template slot="title">
            <span class="headline">基础信息</span>
          </template>
          <!-- 二级菜单 -->
          <el-menu-item index="baseinfo" @click="$router.push({name:'baseinfo',query:params})">公司简介</el-menu-item>
          <el-menu-item
            index="management"
            @click="$router.push({name:'management',query:params})"
          >公司高管</el-menu-item>
          <el-menu-item index="incoming" @click="$router.push({name:'incoming',query:params})">收入构成</el-menu-item>
          <el-menu-item index="employee" @click="$router.push({name:'employee',query:params})">员工构成</el-menu-item>
        </el-submenu>
        <!-- 股本股东 -->
        <el-submenu index="2">
          <template slot="title">
            <span class="headline">股本股东</span>
          </template>
          <el-menu-item
            index="structure"
            @click="$router.push({name:'structure',query:params})"
          >股本结构</el-menu-item>
          <el-menu-item index="major" @click="$router.push({name:'major',query:params})">主要股东</el-menu-item>
          <el-menu-item
            index="circulate"
            @click="$router.push({name:'circulate',query:params})"
          >主要流通股东</el-menu-item>
          <el-menu-item index="fund" @click="$router.push({name:'fund',query:params})">基金持股</el-menu-item>
          <el-menu-item
            index="executive"
            @click="$router.push({name:'executive',query:params})"
          >高管持股</el-menu-item>
          <el-menu-item index="inside" @click="$router.push({name:'inside',query:params})">内部持股变动</el-menu-item>
          <el-menu-item index="sell" @click="$router.push({name:'sell',query:params})">限售解禁</el-menu-item>
        </el-submenu>
        <!-- 发行发配 -->
        <el-submenu index="3">
          <template slot="title">
            <span class="headline">发行分配</span>
          </template>
          <el-menu-item
            index="newmarket"
            @click="$router.push({name:'newmarket',query:params})"
          >新股发行</el-menu-item>
          <el-menu-item index="getpay" @click="$router.push({name:'getpay',query:params})">分红情况</el-menu-item>
          <el-menu-item index="addmore" @click="$router.push({name:'addmore',query:params})">增发</el-menu-item>
          <el-menu-item
            index="sharemarket"
            @click="$router.push({name:'sharemarket',query:params})"
          >配股情况</el-menu-item>
          <el-menu-item
            index="marketplan"
            @click="$router.push({name:'marketplan',query:params})"
          >历年融资计划</el-menu-item>
        </el-submenu>
        <!-- 财务数据 -->
        <el-submenu index="4">
          <template slot="title">
            <span class="headline">财务数据</span>
          </template>
          <el-menu-item
            index="financeinfo"
            @click="$router.push({name:'financeinfo',query:params})"
          >财务摘要表</el-menu-item>
          <el-menu-item
            index="liabilities"
            @click="$router.push({name:'liabilities',query:params})"
          >资产负债表</el-menu-item>
          <el-menu-item
            index="cashcount"
            @click="$router.push({name:'cashcount',query:params})"
          >现金流量表</el-menu-item>
          <el-menu-item index="profit" @click="$router.push({name:'profit',query:params})">利润表</el-menu-item>
          <el-menu-item
            index="forecastpredict"
            @click="$router.push({name:'forecastpredict',query:params})"
          >业绩预告</el-menu-item>
          <el-menu-item
            index="marketrights"
            @click="$router.push({name:'marketrights',query:params})"
          >股东权益增减</el-menu-item>
        </el-submenu>
        <!-- 财务分析 -->
        <el-submenu index="5">
          <template slot="title">
            <span class="headline">财务分析</span>
          </template>
          <el-menu-item index="norm" @click="$router.push({name:'norm',query:params})">每股指标</el-menu-item>
          <el-menu-item index="gain" @click="$router.push({name:'gain',query:params})">盈利能力</el-menu-item>
          <el-menu-item index="repay" @click="$router.push({name:'repay',query:params})">偿还能力</el-menu-item>
          <el-menu-item index="growth" @click="$router.push({name:'growth',query:params})">成长能力</el-menu-item>
          <el-menu-item index="operate" @click="$router.push({name:'operate',query:params})">营运能力</el-menu-item>
          <el-menu-item index="dupont" @click="$router.push({name:'dupont',query:params})">杜邦分析</el-menu-item>
          <el-menu-item index="palepu" @click="$router.push({name:'palepu',query:params})">帕利普分析</el-menu-item>
          <el-menu-item index="zscore" @click="$router.push({name:'zscore',query:params})">Z-分数</el-menu-item>
          <el-menu-item index="fscore" @click="$router.push({name:'fscore',query:params})">F-分数</el-menu-item>
          <el-menu-item index="Bazhory" @click="$router.push({name:'Bazhory',query:params})">巴萨利分数</el-menu-item>
        </el-submenu>
        <!-- 资本运作 -->
        <el-submenu index="6">
          <template slot="title">
            <span class="headline">资本运作</span>
          </template>
          <el-menu-item
            index="controllers"
            @click="$router.push({name:'controllers',query:params})"
          >控股参股</el-menu-item>
          <el-menu-item
            index="participant"
            @click="$router.push({name:'participant',query:params})"
          >参股券商</el-menu-item>
          <el-menu-item index="exchange" @click="$router.push({name:'exchange',query:params})">资产置换</el-menu-item>
          <el-menu-item
            index="transactions"
            @click="$router.push({name:'transactions',query:params})"
          >资产交易</el-menu-item>
          <el-menu-item
            index="divestiture"
            @click="$router.push({name:'divestiture',query:params})"
          >资产剥离</el-menu-item>
        </el-submenu>
        <!-- 重大事项 -->
        <el-submenu index="7">
          <template slot="title">
            <span class="headline">重大事项</span>
          </template>
          <el-menu-item index="pledge" @click="$router.push({name:'pledge',query:params})">股权质押</el-menu-item>
          <el-menu-item
            index="reorganization"
            @click="$router.push({name:'reorganization',query:params})"
          >并购重组</el-menu-item>
          <el-menu-item
            index="meetingnotice"
            @click="$router.push({name:'meetingnotice',query:params})"
          >股东大会通知</el-menu-item>
          <el-menu-item
            index="violation"
            @click="$router.push({name:'violation',query:params})"
          >违规记录</el-menu-item>
          <el-menu-item
            index="arbitration"
            @click="$router.push({name:'arbitration',query:params})"
          >诉讼仲裁</el-menu-item>
          <el-menu-item
            index="guarantee"
            @click="$router.push({name:'guarantee',query:params})"
          >对外担保</el-menu-item>
        </el-submenu>
        <!-- 公告资讯 -->
        <el-submenu index="8">
          <template slot="title">
            <span class="headline">公告资讯</span>
          </template>
          <el-menu-item
            index="announcement"
            @click="$router.push({name:'announcement',query:params})"
          >公司公告</el-menu-item>
          <el-menu-item
            index="cinformation"
            @click="$router.push({name:'cinformation',query:params})"
          >公司资讯</el-menu-item>
          <el-menu-item
            index="hinformation"
            @click="$router.push({name:'hinformation',query:params})"
          >行业资讯</el-menu-item>
        </el-submenu>
      </el-menu>
    </div>
  </div>
</template>
<script>
import magic from "@/../static/common/magic.js";
export default {
  props: {},
  components: {},
  data() {
    return {
      params: {},
      openeds: ["1"] //导航栏展开
    };
  },
  computed: {},
  methods: {
    getParams() {
      let creditCode = magic.getUrlKey("creditCode"); //假数据
      this.params["creditCode"] = creditCode;
    }
  },
  created() {
    //判断是否有权限，是否登录
    window.that = this;
    magic.loginOrRights(0).then(res => {
      if (!res) {
        // that.$router.push({ path:'/login'});
        this.$router.push({
          path: "/login",
          query: {
            repath: window.location.href
          }
        });
      }
      if (res && res.rights == 0) {
        that.$router.push({ path: "/index" });
      }
    });
  },
  mounted() {
    this.getParams();
  }
};
</script>
<style scoped lang="less">
// 左侧菜单栏
.left {
  width: 240px;
  height: auto;
  min-height: 80vh;
  margin-right: 23px;
  border: 1px solid #08396a;
  .leftBox {
    width: auto;
    height: auto;
    padding: 3px 14px 26px 14px;
    .headline {
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: bold;
    }
    .el-menu {
      border-right: none;
    }
    /deep/ .el-submenu__icon-arrow {
      right: 2px;
    }
    /deep/ .el-submenu__title {
      height: 47px;
      line-height: 47px;
      padding: 0;
      padding-left: 5px !important;
      border-bottom: 1px dashed #08396a;
    }
    .el-submenu .el-menu-item {
      padding-left: 25px !important;
      height: 40px;
      line-height: 40px;
    }
    /deep/ .el-submenu__title:hover {
      background-color: #f2f4f7 !important;
      color: #000 !important;
    }

    .el-menu-item:hover {
      background-color: #f2f4f7 !important;
      color: #000 !important;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/left.vue